import { Chip } from '@mui/material';
import { TestStatus, TestStatusLabels, TestStatusColors, parseTestStatus } from '@/types/test';

interface TestStatusBadgeProps {
  status: string | TestStatus;
  size?: 'small' | 'medium';
}

/**
 * Badge component to display test status with appropriate color and label
 */
export function TestStatusBadge({ status, size = 'small' }: TestStatusBadgeProps) {
  const testStatus = typeof status === 'string' ? parseTestStatus(status) : status;
  const label = TestStatusLabels[testStatus] || status;
  const color = TestStatusColors[testStatus] || 'default';

  return (
    <Chip
      label={label}
      color={color}
      size={size}
    />
  );
}